const errorCodes = {
  UserAccountExpiredException: 52,
  TokenMalformedException: 61,
  TokenExpiredException: 62,
  TokenInvalidException: 63,
  InvalidRequestDataException: 102,
  InvalidBusinessProfileRequested: 112,
  ForbiddenBusinessProfileRequested: 113,
  Unauthorized: 401,
  InvalidHashkeyRequested: 60,
  EntityAlreadyExistsError: 101,
  EntityDoesNotExistException: 104,
  EntityNotFoundInCacheException: 308,
  InvalidLoginCredentials: 51,
  ForbiddenPortalRequested: 56,
  InvalidPortalRequestedException: 55,
  PasswordExpiredException: 74,
  RefreshTokenExpiredException: 76,
  InvalidCustomAttributeOperationException: 1005
};

export default errorCodes;
